import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
// import { getOurCulturePhotos} from "../actions";
import { getJobListingDraftApi } from '../../API/API'

function* getJobListingDraftSaga(params) {
  try {
    const response = yield call(() => getJobListingDraftApi(params)); // API Backend
    yield put({ type: types.GET_JOB_LISTING_DRAFT_SUCCESS, payload: response.data });
    // yield put(fetchDataSuccess(response.data));
  } catch (error) {
    yield put({ type: types.GET_JOB_LISTING_DRAFT_FAILURE, error });
  }
}

function* getJobListingNewDraftSaga(params) {
  try {
    const response = yield call(() => getJobListingDraftApi(params)); // API Backend
    yield put({ type: types.GET_JOB_RESULT_LISTING_SUCESS_DRAFT, payload: response.data });
    // yield put(fetchDataSuccess(response.data));
  } catch (error) {
    yield put({ type: types.GET_JOB_LISTING_DRAFT_FAILURE, error });
  }
}

export function* watchGetJobListingDraft() {
  yield takeEvery(types.GET_JOB_LISTING_DRAFT, getJobListingDraftSaga);
}

export function* watchGetJobListingNewDraft() {
  yield takeEvery(types.GET_JOB_RESULT_LISTING_DRAFT, getJobListingNewDraftSaga);
}